import React from 'react';
import { Link } from 'react-router-dom';

const withAccessAllowed = (WrappedComponent, isAllowed) => {
    return (props) => {
        if (isAllowed) {
            return <WrappedComponent {...props} />
        }
        return (
            <div className="no-access-page" style={{display: 'grid', placeItems: 'center'}}>
                <h1>Access Denied!!</h1>
                <p>You do not have permission to view this page.</p>
                <Link to="/">Go Back Home</Link>
            </div>
        )
    }
}

export default withAccessAllowed;